import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { MarketplaceDesc } from './getMarketplaceDesc'

const updateMarketplaceDesc = (marketplace: string, desc: MarketplaceDesc) => async (
    _dispatch: Dispatch,
    getState: () => RootState,
): Promise<MarketplaceDesc | null> => {
    const { userData } = getState()
    const params = {
        userId: userData.smsAuth.userId,
        marketplace,
        data: {
            prefix: desc.prefix,
            suffix: desc.suffix,
            order: desc.order,
        },
    }
    const config = {
        headers: {
            Authorization: `${anchor} ${localStorage.getItem('accessToken')}`
        }
    }
    try {
        const { data: { status, data } } = await apiInstance.post('/sales/marketplaces/updateMarketplaceDesc', params, config)
        if (status === 'ok' && data) {
            return {
                prefix: data.prefix || '',
                suffix: data.suffix || '',
                order: Array.isArray(data.order) ? data.order : desc.order,
            }
        }
    } catch (e) {
        console.error('update marketplace description failed', e)
    }
    return null
}

export default updateMarketplaceDesc
